import axios, { AxiosError, AxiosInstance } from 'axios';

let axiosInstance: AxiosInstance;

/**
 * A simple wrapper around axios for making API calls to Next.js API endpoints (BFF API Gateway).
 * All paths should be relative with a leading slash.
 *
 * Example:
 *    ```
 *    bff().get('/courses');
 *    ```
 */
export function bff() {
   if (typeof window === 'undefined') {
      throw new Error('bff() can only be called in the browser!');
   }

   if (!axiosInstance) {
      axiosInstance = axios.create({ baseURL: window.location.origin + '/bff-api' });
   }

   // Sets content type for all requests
   axiosInstance.defaults.headers.common['Content-Type'] = 'application/json';

   return axiosInstance;
}

export function isBffError(error: unknown): error is AxiosError {
   return Boolean(
      typeof error === 'object' &&
         (error instanceof AxiosError ||
            (error?.hasOwnProperty('isAxiosError') && (error as AxiosError).isAxiosError))
   );
}

export function isUnauthenticatedError(error: unknown): error is AxiosError {
   return isBffError(error) && error.response?.status === 401;
}

export function isForbiddenError(error: unknown): error is AxiosError {
   return isBffError(error) && error.response?.status === 403;
}
